import { render, staticRenderFns } from "./mediaPlatformPhoto.vue?vue&type=template&id=5d06276d&scoped=true&"
import script from "./mediaPlatformPhoto.vue?vue&type=script&lang=js&"
export * from "./mediaPlatformPhoto.vue?vue&type=script&lang=js&"
import style0 from "./mediaPlatformPhoto.vue?vue&type=style&index=0&id=5d06276d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d06276d",
  null
  
)

component.options.__file = "mediaPlatformPhoto.vue"
export default component.exports